export default __webpack_public_path__ + "static/media/condense-icon-mobile.de17ce3a.svg";